import { useCallback, useEffect, useState } from "react";

import { TableDashboard } from "@atoms";
import useApiFetch from "@hooks/useApiFetch";
import useCsvExportButton from "@hooks/useCsvExportButton";
import useQueryParams from "@hooks/useQueryParams";

import PlanTable from "./PlanProducts/PlanTable";

const Plans = () => {
  const { get, getCached, isPending } = useApiFetch();
  const [refresh, setRefresh] = useState(false);

  const [plansTableData, setPlansTableData] = useState({
    custodians: [],
    recordKeepers: [],
    productTypes: [],
  });

  const { getQueryParams } = useQueryParams();
  const search = getQueryParams("search");

  const {
    csvClickRef,
    csvData: { data = [] },
    getExport,
    loadingResponse,
  } = useCsvExportButton();

  const handleCsvExport = () => {
    const queryParams = search ? `?Search=${search}` : "";
    getExport(`plans/plansExport${queryParams}`);
  };

  const updateFetchData = useCallback((field, value) => {
    setPlansTableData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const fetchPlanHelpersData = async () => {
    const requests = [
      {
        field: "custodians",
        request: () => getCached("custodians/get", { cacheKey: "custodians" }),
      },
      {
        field: "recordKeepers",
        request: () =>
          getCached("recordkeepers/get", { cacheKey: "recordkeepers" }),
      },
      { field: "productTypes", request: () => get("products/productTypes") },
    ];

    const results = await Promise.allSettled(
      requests.map((item) => item.request())
    );

    requests.forEach((item, index) => {
      const { status, value } = results[index];
      const data = item.field === "productTypes" ? value : value?.data;
      const result = status === "fulfilled" ? data : "";
      updateFetchData(item.field, result);
    });
  };

  useEffect(() => {
    fetchPlanHelpersData();
  }, []);

  return (
    <TableDashboard
      pageTitle="Plans"
      navigatePath="/plans/add"
      setRefresh={setRefresh}
      exportCsvProps={{
        fileName: "PlansList",
        csvClickRef,
        csvData: data,
        getCsvExport: handleCsvExport,
        loadingResponse,
      }}
    >
      <PlanTable
        isLoading={isPending}
        refresh={refresh}
        setRefresh={setRefresh}
        plansTableData={plansTableData}
      />
    </TableDashboard>
  );
};

export default Plans;
